<template>
    <v-layout class="scrollbar-custom">
        <component
            :is="triggerComponent"
            :callback="displayDialog"
            :application="application"
        ></component>
        <v-dialog
            v-model="displayed"
            max-width="450px"
            light
            :persistent="true"
            :no-click-animation="true"
        >
            <v-card class="dialog-content">
                <v-icon
                    large
                    class="close-view-icon"
                    @click="closeView"
                >
                    close
                </v-icon>
                <v-card-text>
                    <v-card-title primary-title>
                        <div class="application-modal-headline">
                            {{ triggerComponent === 'app-btn'? $t('application.form-create-app.modal_headline_details'): $t('application.form-create-app.modal_headline_create')}}
                        </div>
                        <div v-html="$t('application.form-create-app.modal_headline_descr')" class="headline-description"></div>
                    </v-card-title>
                    <v-form ref="applicationForm" v-on:submit.prevent>
                        <v-container>
                            <v-row dense>
                                <v-col cols="12">
                                    <v-text-field
                                        :label="$t('application.form-create-app.name_field_label')"
                                        v-model="form.name"
                                        :value="form.name"
                                        :rules="formRules.name"
                                        required
                                    ></v-text-field>
                                    <p class="name-description">{{$t('application.form-create-app.app_name_description')}}</p>
                                </v-col>
                                <v-col cols="12">
                                    <h3 class="application-image-title">{{$t('application.form-create-app.image_field_label')}}</h3>
                                    <crop-image
                                        v-model="form.filename"
                                        clearable
                                        :imageWidth="100"
                                        :imageHeight="100"
                                        imageMinScaling="contain"
                                        :fullWidth="true"
                                        ref="crop"
                                    >
                                    </crop-image>
                                </v-col>
                                <v-col cols="12">
                                    <label class="v-label theme--light">
                                        {{$t('application.form-create-app.color_field_label')}}
                                    </label>
                                    <v-color-picker
                                        v-model="form.color"
                                        :swatches="swatches"
                                        mode="hexa"
                                        dot-size="25"
                                        canvas-height="100"
                                        hide-sliders
                                        show-swatches
                                        hide-mode-switch
                                        class="mt-2 mx-auto"
                                    ></v-color-picker>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-row justify="end" class="app-create-confirm-buttons">
                        <v-col cols="3" class="mr-3">
                            <v-btn
                                @click="displayed = false"
                            >
                                {{$t('application.form-create-app.btn_cancel')}}
                            </v-btn>
                        </v-col>

                        <v-col cols="3" class="mr-5">
                            <v-btn
                                color="info"
                                @click="saveApplication"
                            >
                                {{ update ? $t('application.form-create-app.btn_save') : $t('application.form-create-app.btn_create') }}
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <dialog-max-instance-reached ref="max-instance-reached"></dialog-max-instance-reached>
    </v-layout>
</template>

<script>
import {mapActions} from 'vuex';
import CreateBtn from '../../Partials/create-new-button.vue';
import AppBtn from '@/components/Partials/app-btn.vue';
import openDialogMixin from './open-dialog-mixin.vue';
import DialogMaxInstanceReached from '@/components/Partials/dialog-max-running-instance-reached';
import CropImage from 'vuetify-image-input';

export default {

    mixins: [openDialogMixin],

    components: {
        CreateBtn,
        AppBtn,
        CropImage,
        DialogMaxInstanceReached,

    },

    props: {
        triggerComponent: {
            type: String,
            required: true,
        },
        application: {
            type: Object,
            required: false,
            default: () => {
                return null;
            },
        },
        update: {
            type: Boolean,
            default: false
        },
        applicationsCount: {
            type: Number,
            default: 0
        }
    },

    data: function(){
        return {
            editApp: false,
            form: {
                name: '',
                color: '#F44336',
                file: null,
                filename: '',
                fileUrl: '',
            },

            formRules: {
                name: [
                    v => !!v || this.$t('application.form-create-app.form_rule_name-empty'),
                    v => v ? v.length <= 255 : this.$t('application.form-create-app.form_rule_name-length')
                ],
            },
            swatches: [
                ['#1FBC9C', '#3398DB', '#F2C511', '#3D556E'],
                ['#1CA085', '#2980B9', '#F39C19', '#222F3D'],
                ['#2ECC70', '#A463BF', '#E84B3C', '#BDC3C8'],
                ['#27AF60', '#8E43AD', '#C0382B', '#DDE6E8'],
            ],
        };
    },

    watch: {
    },

    mounted: function(){
        if(this.application) {
            this.editApp = true;
        }
    },

    methods: {
        createUuidv4() {
            return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
            );
        },

        logMessage(success, appName) {
            if(success) {
                return this.editApp ?
                    this.$t('application.form-create-app.log_success_updated', { appName: appName })
                    : this.$t('application.form-create-app.log_success_created', { appName: appName });
            }
            return this.editApp ?
                this.$t('application.form-create-app.log_error_updated', { appName: appName })
                : this.$t('application.form-create-app.log_error_created', { appName: appName });
        },

        async displayDialog() {
            if (window.config.free_version && this.applicationsCount >= window.config.max_applications_allowed){
                this.$refs['max-instance-reached'].open();
                return
            }
            else if(!this.editApp && this.$refs.applicationForm) {
                this.resetForm();
                this.$refs.applicationForm.resetValidation();
            } else if(this.editApp){
                this.form.name = this.application.label;
                this.form.color = this.application.color;
                this.form.fileUrl = this.application.image || '';
                if(this.form.fileUrl) {
                    let file = await new Promise(resolve => {
                        fetch(this.form.fileUrl)
                            .then(res => res.blob())
                            .then(blob => {
                                var reader = new FileReader();
                                reader.onloadend = function() {
                                    resolve(reader.result);
                                };
                                reader.readAsDataURL(blob);
                                // resolve(objectURL);
                            });
                    });
                    this.form.filename = file;
                } else {
                    this.form.filename = '';
                }
            }
            this.openDialog();
            this.generateCustomColorInputLabel();
        },

        async saveApplication() {
            if(this.$refs.applicationForm.validate()) {
                let formData = new FormData();
                formData.append('label', this.form.name);
                formData.append('color', this.form.color);
                if(this.form.filename) {
                    var file = await new Promise(resolve => {
                        fetch(this.form.filename)
                            .then(res => res.blob())
                            .then(blob => {
                                resolve(new File([blob], 'File name.jpg', {type: 'image/jpg'}));
                            });
                    });

                    formData.append('image', file);
                }
                if(this.form.filename === null) {
                    // this means the user has deleted the previous img
                    formData.append('image', '');
                }

                let success = false;
                this.generateRequest(formData).then((val) => {
                    let userUid = this.createUuidv4();
                    let groupUid = this.createUuidv4();
                    success = true;
                    this.displaySuccessSnackbar();
                    this.$refs.crop.clear();
                    this.displayed = false;
                    // to reload ns-paginate
                    this.$emit('reloadApplications');
                    // to reload app-btn
                    this.$emit('reloadApplication', val.data);
                    if(!this.editApp){
                        this.$store.dispatch('createItem', {
                            item:{
                                application_uid: val.data.uid,
                                editable: true,
                                value: {
                                    'manifest':{
                                        'attributes':[],
                                        'version':'1.0.0',
                                        'data_modeling':{
                                            'many_to_many_relations':[
                                                {
                                                    'target_model': {
                                                        uid: userUid,
                                                        name: 'User'
                                                    },
                                                    'source_field':'members',
                                                    'source_model': {
                                                        'uid': groupUid,
                                                        'name':'Group'
                                                    }
                                                }
                                            ],
                                            'application_id':'',
                                            'roles':[],
                                            'models':[
                                                {
                                                    'fields':[
                                                        {
                                                            'datatype':'char',
                                                            'attributes':{},
                                                            'name':'email'
                                                        },
                                                        {
                                                            'datatype':'char',
                                                            'attributes':{},
                                                            'name':'first_name'
                                                        },
                                                        {
                                                            'datatype':'char',
                                                            'attributes':{},
                                                            'name':'last_name'
                                                        }
                                                    ],
                                                    'description':null,
                                                    'uid': userUid,
                                                    'name':'User',
                                                    'representation_field':'email',
                                                    'is_default_public':false,
                                                    'model_description': ''
                                                },
                                                {
                                                    'fields':[
                                                        {
                                                            'datatype':'char',
                                                            'attributes':{},
                                                            'name':'name'
                                                        },
                                                        {
                                                            'datatype':'m2m',
                                                            'attributes':{
                                                                'to': {
                                                                    uid: userUid,
                                                                    name: 'User'
                                                                },
                                                                'reverse':'concrete_groups'
                                                            },
                                                            'name':'members'
                                                        }
                                                    ],
                                                    'description':null,
                                                    'uid': groupUid,
                                                    'name':'Group',
                                                    'representation_field':'name',
                                                    'is_default_public':false
                                                }
                                            ],
                                            'one_to_many_relations':[],
                                            'version':'1.0.0',
                                            'resource_queries':[
                                                {
                                                    'model_uid':userUid,
                                                    'model_name':'User',
                                                    'ordering_fields':[],
                                                    'search_fields':[
                                                        'email'
                                                    ],
                                                    'filter_fields':[
                                                        'email'
                                                    ],
                                                    'display_fields':[
                                                        'email',
                                                        'first_name',
                                                        'last_name'
                                                    ],
                                                    'export_fields':[]
                                                },
                                                {
                                                    'model_uid':groupUid,
                                                    'model_name':'Group',
                                                    'ordering_fields':[],
                                                    'search_fields':[
                                                        'name'
                                                    ],
                                                    'filter_fields':[
                                                        'name'
                                                    ],
                                                    'display_fields':[
                                                        'name'
                                                    ],
                                                    'export_fields':[]
                                                }
                                            ],
                                            'attributes':[],
                                            'permissions':[
                                                {
                                                    'lookups': [],
                                                    'model_uid': userUid,
                                                    'model_name': 'User',
                                                    'minimum_levels':{
                                                        'create': 'manager',
                                                        'delete': 'manager',
                                                        'update': 'authenticated',
                                                        'retrieve': 'authenticated'
                                                    }
                                                },
                                                {
                                                    'lookups': [],
                                                    'model_uid': groupUid,
                                                    'model_name': 'Group',
                                                    'minimum_levels': {
                                                        'create': 'manager',
                                                        'delete': 'admin',
                                                        'update': 'manager',
                                                        'retrieve': 'authenticated'
                                                    }
                                                }
                                            ]
                                        }
                                    }
                                }
                            },
                            url: this.$store.state.api.meta.listModels.modelisations.url,
                            model: 'modelisations',
                            scopes: this.$store.state.api.scopes || {},
                        });
                    }
                }).catch((error) => {
                    this.displayErrorSnackbar();
                    console.error(error);
                }).finally(() => {
                    this.$store.dispatch('createLog', {
                        message: this.logMessage(success, this.form.name),
                        origin: 'Application',
                    });
                });
            }
        },

        createApplication(formData) {
            return this.$store.axios.post(
                `${this.$store.getters.apiRootUrl}/application/`,
                formData,
                {headers: {'Content-Type': 'multipart/form-data', ...this.$store.state.api.scopes}}
            );
        },

        editApplication(formData) {
            return this.$store.axios.patch(this.application.url, formData,
                    {headers: {'Content-Type': 'multipart/form-data',}});
        },

        generateRequest(formData) {
            return this.editApp ?
                this.editApplication(formData)
                : this.createApplication(formData);
        },

        displaySuccessSnackbar() {
            let text = this.editApp ?
                this.$t('application.form-create-app.update_success')
                : this.$t('application.form-create-app.creation_success');
            this.$store.commit('SET_SNACKBAR', {
                color: 'success',
                icon: 'done',
                text: text,
            });
            this.$store.commit('SET_DISPLAY_SNACKBAR', true);
        },

        displayErrorSnackbar() {
            let text = this.editApp ?
                this.$t('application.form-create-app.update_error')
                : this.$t('application.form-create-app.update_error');
            this.$store.commit('SET_SNACKBAR', {
                color: 'error',
                icon: 'error',
                text: text,
            });
            this.$store.commit('SET_DISPLAY_SNACKBAR', true);
        },

        resetForm() {
            this.form.file = null;
            this.form.fileUrl = '';
            this.form.filename = '';
            this.form.color = '#F44336';
            this.form.name = '';
        },
        closeView() {
            this.displayed = false;
        },
    },
};
</script>

<style lang="scss">
.dialog-content{
    .close-view-icon{
        position: absolute !important;
        right: 8px;
        top: 15px;
    }
    .v-card__text {
        padding: 20px 24px 0 !important;
        .v-card__title{
            padding-bottom: 0;
            color: rgba(0,0,0,.54);
        }
    }
    .app-create-confirm-buttons {
        padding-bottom: 20px;
    }

}

.v-form>.container{
    padding-bottom: 0;
}
.application-image-title {
    color: $main-light-color;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 20px;
}
.application-modal-headline {
    width: 100%;
    font-weight: normal;
    font-size: 24px;
    color: $main-light-color;
}
.headline-description{
    font-size: 16px;
    line-height: 24px;
    margin-top: 10px;
    word-break: break-word;
    color: $main-light-color;
}
.close-view-icon{
    float: right;
}
.name-description{
    color: gray;
    font-size: 12px;
    font-style: italic;
}
.color-picker-label{
    color: $main-light-color;
}
</style>



// WEBPACK FOOTER //
// src/components/page/Application/form-create-app.vue